import { TextCodes } from '@api/types/translation/TextCodes';
import { Button, SmartLink } from '@components';
import { useAppSelector, useAuth } from '@hooks';
import { PinDrop } from '@mui/icons-material';
import { getSpecialPage } from '@store/app/app.slice';
import { t } from '@translations';

export const ProductDealerInfo = () => {
  const findDealerPage = useAppSelector(getSpecialPage('findDealerPage'));
  const { isAuthenticated } = useAuth();
  return !isAuthenticated ? (
    <Button
      variant='secondary'
      startIcon={<PinDrop />}
      fullWidth
      href={findDealerPage}
      LinkComponent={SmartLink}
      sx={{
        span: {
          margin: 0,
          gap: 1,
          display: 'flex',
          alignItems: 'center',
        },
      }}
    >
      {t(TextCodes.Product.Details.LocateDealer)}
    </Button>
  ) : null;
};
